import React from 'react';
// import Publications from '../components/Publications';
import Layout from '../components/layout/Layout';
import { Helmet } from "react-helmet"
import { Link } from "gatsby"

/* This example requires Tailwind CSS v2.0+ */
const posts = [
  {
    title: 'Migrating billion+ documents from Elastic Search to AWS S3',
    href: '/blogs/elastic-search-to-s3-data-migration',
    category: { name: 'Article', href: '#' },
    description:
      'Blog provides simple solution to move enormous volumes of data stashed in ES to S3',
    date: 'May 30, 2021',
    datetime: '2021-05-30',
    imageUrl:
      'https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80',
    readingTime: '6 min',
    /* author: {
      name: '',
      href: 'https://blogc4scalecom.wordpress.com/?p=15',
      imageUrl:
        'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    }, */
  },
  /* {
    title: 'How to build a tech start up team that maximises productivity',
    href: '#',
    category: { name: 'Video', href: '#' },
    description:
      'The most challenging task and confusion for a start up founder is to figure out how many geeks are needed in his team.',
    date: 'Mar 10, 2020',
    datetime: '2020-03-10',
    imageUrl:
      'https://images.unsplash.com/photo-1547586696-ea22b4d4235d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80',
    readingTime: '4 min', 
    },
  {
    title: 'Why should your software backend for your start up should be a monolith?',
    href: '#',
    category: { name: 'Case Study', href: '#' },
    description:
      'Should I start working on micro-services that are my building blocks? Or Should I start it all-in-one monolith service?',
    date: 'Feb 12, 2020',
    datetime: '2020-02-12',
    imageUrl:
      'https://images.unsplash.com/photo-1492724441997-5dc865305da7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80',
    readingTime: '5 min',
    }, */
]

export default function Example() {
  return (
      <>
      <Layout>
        <Helmet>
          <meta charSet="utf-8" />
          <title>C4Scale - Blogs</title>
          <meta name="description" content="Blogs &amp; articles at C4Scale" />
        </Helmet>
    <div className="relative bg-gray-50 pt-16 pb-20 px-4 sm:px-6 lg:pt-24 lg:pb-28 lg:px-8">
      <div className="absolute inset-0">
        <div className="bg-white h-1/3 sm:h-2/3" />
      </div>
      <div className="relative max-w-7xl mx-auto">
        <div className="text-center">
          <h2 className="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl">Limitless Possibilities | Tech @C4Scale</h2>
          <p className="mt-3 max-w-2xl mx-auto text-xl text-gray-600 sm:mt-4">
            
          </p>
        </div>
        <div className="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none">
          {posts.map((post) => (
            <div key={post.title} className="flex flex-col rounded-lg shadow-lg overflow-hidden">
              <div className="flex-shrink-0">
                <img className="h-48 w-full object-cover" src={post.imageUrl} alt="" />
              </div>
              <div className="flex-1 bg-white p-6 flex flex-col justify-between">
                <div className="flex-1">
                  <p className="text-sm font-medium text-indigo-600">
                    <Link to={post.category.href} className="hover:underline">
                      {post.category.name}
                    </Link>
                  </p>
                  <Link to={post.href} className="block mt-2">
                    <p className="text-xl font-semibold text-gray-900">{post.title}</p>
                    <p className="mt-3 text-base text-gray-600">{post.description}</p>
                  </Link>
                </div>
                <div className="mt-6 flex items-center">
                  {/* <div className="flex-shrink-0">
                    <a href={post.author.href}>
                      <span className="sr-only">{post.author.name}</span>
                      <img className="h-10 w-10 rounded-full" src={post.author.imageUrl} alt="" />
                    </a>
                  </div> */}
                  <div className="ml-3">
                    {/* <p className="text-sm font-medium text-gray-900">
                      <a href={post.author.href} className="hover:underline">
                        {post.author.name}
                      </a>
                    </p> */}
                    <div className="flex space-x-1 text-sm text-gray-600">
                      <time dateTime={post.datetime}>{post.date}</time>
                      <span aria-hidden="true">&middot;</span>
                      <span>{post.readingTime} read</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
    {/* <Publications/> */}
      </Layout>
    </>
  )
}
